import * as React from "react";
import * as _ from "lodash";
import { IPatientRedFlag } from "@curefit/ehr-common";
import IStaticDataValue from "../../../../../common/models/IStaticDataValue";
import ToggleButtonList from "../../ToggleButtonList";

/**
 * Created by prachi on 16/03/18.
 */


export interface PatientRedFlagsViewProps {
    allRedFlags: IStaticDataValue[],
    selectedRedFlags: IPatientRedFlag,
}

class PatientRedFlagsView extends React.Component<PatientRedFlagsViewProps> {
    onSelectionChange = (updatedSelections: string[]) => {
        // view only
    }

    getSelectionStringArray = (troubles: IStaticDataValue[]) => {
        return troubles !== undefined && troubles !== null ? troubles.map(item => item.internalValue) : [];
    }

    render() {
        let comment = !_.isEmpty(this.props.selectedRedFlags) && !_.isNull(this.props.selectedRedFlags) && this.props.selectedRedFlags.comment !==  null ? this.props.selectedRedFlags.comment : "";
        let troubles = !_.isEmpty(this.props.selectedRedFlags) && !_.isNull(this.props.selectedRedFlags) ? this.getSelectionStringArray(this.props.selectedRedFlags.troubles) : []
        return (
            <div className="patient-red-flags-view">
                <ToggleButtonList listItems={this.props.allRedFlags} selectedItems={troubles} onSelectionChange={this.onSelectionChange}/>
                <div className="red-flag-comments">
                    {comment}
                </div>
            </div>
        );
    }
}

export default PatientRedFlagsView